import React from 'react';
import cx from 'clsx';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Typography, { TypographyProps } from '@material-ui/core/Typography';
import TableCell, { TableCellProps } from '@material-ui/core/TableCell';
import Popover from '../Popover';

const useStyles = makeStyles<Theme>(theme => {
  return {
    typographyContent: {
      color: '#4A4A4A',
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 600,
      textTransform: 'uppercase',
      height: '100%',
      lineHeight: '23px'
    },
    container: {
      display: 'flex',
      marginRight: '10px'
    },
    iconSize: {
      width: '10px'
    },
    iconContainer: {
      height: '10px',
      width: '5px'
    }
  };
});

interface TableHeadCellProps extends TableCellProps {
  helpText?: string;
  onClick?: any;
  sortFn?: (a: any, b: any) => number;
  SortIcon?: React.ReactNode;
  typographyProps?: Omit<TypographyProps, 'children'>;
  innerContainerProps?: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >;
  iconContainerProps?: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLSpanElement>,
    HTMLSpanElement
  >;
}

const TableHeadCell: React.FC<TableHeadCellProps> = ({
  children,
  helpText,
  onClick,
  sortFn,
  SortIcon,
  typographyProps = {},
  innerContainerProps = {},
  iconContainerProps = {},
  ...rest
}) => {
  const classes = useStyles();

  const cellContent = (
    <div
      onClick={(event: React.MouseEvent<HTMLDivElement>): void => onClick(event, sortFn)}
      {...innerContainerProps}
      className={classes.container}
    >
      {typeof children === 'string' ? (
        <Typography
          component="span"
          className={cx(classes.typographyContent, typographyProps.className)}
        >
          {children}
        </Typography>
      ) : (
        children
      )}
      {SortIcon && (
        <span className={classes.iconContainer} {...iconContainerProps}>
          {SortIcon}
        </span>
      )}
    </div>
  );

  return (
    <TableCell role="columnheader" {...rest}>
      {helpText ? (
        <Popover description={helpText} centerIcon={false}>
          {cellContent}
        </Popover>
      ) : (
        cellContent
      )}
    </TableCell>
  );
};

export default TableHeadCell;
